import React, {Component} from 'react';
import LandingPage from "../components/landing-page/LandingPage";

class OffersLandingPage extends Component {
    render() {
        return (
            <div className='offers-landing-page'>
                <LandingPage />
            </div>
        );
    }
}

export default OffersLandingPage;